import * as api from 'src/actions/api';
import * as ui from 'src/actions/ui';
//import * as ws from 'src/actions/ws';

export const actions = {
  api,
  ui,
  // ws,
};
